import * as allActions from "./actions";
import * as allConstants from "./constants";
import * as allSelectors from "./selectors";

export { default as saga } from "./saga";
export { RecognitionReducer as reducer } from "./reducer";

export const actions = allActions;
export const constants = allConstants;
export const selectors = allSelectors;
